/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as RoleplayRouteImport } from './routes/roleplay'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppDemoRouteImport } from './routes/_app/demo'
import { Route as AppDocumentsRouteImport } from './routes/_app/documents'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppJourneyTypesRouteImport } from './routes/_app/journey-types'
import { Route as AppJourneysRouteImport } from './routes/_app/journeys'
import { Route as AppMeetingTemplatesRouteImport } from './routes/_app/meeting-templates'
import { Route as AppMessagesRouteImport } from './routes/_app/messages'
import { Route as AppNpsResponsesRouteImport } from './routes/_app/nps-responses'
import { Route as AppSkillsRouteImport } from './routes/_app/skills'
import { Route as AuthErrorRouteImport } from './routes/auth.error'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminBrevoRouteImport } from './routes/_app/admin/brevo'
import { Route as AppAdminBroadcastRouteImport } from './routes/_app/admin/broadcast'
import { Route as AppAdminBulkImportRouteImport } from './routes/_app/admin/bulk-import'
import { Route as AppAdminChangeLogsRouteImport } from './routes/_app/admin/change-logs'
import { Route as AppAdminFeatureFlagsRouteImport } from './routes/_app/admin/feature-flags'
import { Route as AppAdminMaintenanceRouteImport } from './routes/_app/admin/maintenance'
import { Route as AppAdminMcpRouteImport } from './routes/_app/admin/mcp'
import { Route as AppAdminOutreachQueueRouteImport } from './routes/_app/admin/outreach-queue'
import { Route as AppAdminPipelineRouteImport } from './routes/_app/admin/pipeline'
import { Route as AppAdminRecommendationsRouteImport } from './routes/_app/admin/recommendations'
import { Route as AppAdminScheduledTasksRouteImport } from './routes/_app/admin/scheduled-tasks'
import { Route as AppAdminSkillBroadcastsRouteImport } from './routes/_app/admin/skill-broadcasts'
import { Route as AppAdminStaffMcpRouteImport } from './routes/_app/admin/staff-mcp'
import { Route as AppAdminUnansweredRouteImport } from './routes/_app/admin/unanswered'
import { Route as AppCohortsIndexRouteImport } from './routes/_app/cohorts/index'
import { Route as AppCohortsCreateRouteImport } from './routes/_app/cohorts/create'
import { Route as AppConversationReviewsIndexRouteImport } from './routes/_app/conversation-reviews/index'
import { Route as AppConversationReviewsIdRouteImport } from './routes/_app/conversation-reviews/$id'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppDashboardCostsRouteImport } from './routes/_app/dashboard/costs'
import { Route as AppDashboardMetricsHistoryRouteImport } from './routes/_app/dashboard/metrics-history'
import { Route as AppDashboardPageUsageRouteImport } from './routes/_app/dashboard/page-usage'
import { Route as AppDashboardQuestionsRouteImport } from './routes/_app/dashboard/questions'
import { Route as AppInsightsIndexRouteImport } from './routes/_app/insights/index'
import { Route as AppJourneyTypesIndexRouteImport } from './routes/_app/journey-types/index'
import { Route as AppJourneyTypesNewRouteImport } from './routes/_app/journey-types/new'
import { Route as AppJourneysIndexRouteImport } from './routes/_app/journeys/index'
import { Route as AppJourneysNewRouteImport } from './routes/_app/journeys/new'
import { Route as AppMeetingTemplatesIndexRouteImport } from './routes/_app/meeting-templates/index'
import { Route as AppOrganisationsIndexRouteImport } from './routes/_app/organisations/index'
import { Route as AppOrganisationsCreateRouteImport } from './routes/_app/organisations/create'
import { Route as AppSkillsIndexRouteImport } from './routes/_app/skills/index'
import { Route as AppSkillsCreateRouteImport } from './routes/_app/skills/create'
import { Route as AppTopicsIndexRouteImport } from './routes/_app/topics/index'
import { Route as AppTopicsIdRouteImport } from './routes/_app/topics/$id'
import { Route as AppTracesTraceIdRouteImport } from './routes/_app/traces/$traceId'
import { Route as AppTracksIndexRouteImport } from './routes/_app/tracks/index'
import { Route as AppTracksCreateRouteImport } from './routes/_app/tracks/create'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppUsersCreateRouteImport } from './routes/_app/users/create'
import { Route as AppAdminNotificationsIndexRouteImport } from './routes/_app/admin/notifications/index'
import { Route as AppAdminRecommendationRunsIndexRouteImport } from './routes/_app/admin/recommendation-runs/index'
import { Route as AppCohortsIdIndexRouteImport } from './routes/_app/cohorts/$id.index'
import { Route as AppCohortsIdEditRouteImport } from './routes/_app/cohorts/$id.edit'
import { Route as AppInsightsRoutinesNewRouteImport } from './routes/_app/insights/routines.new'
import { Route as AppInsightsRunsIdRouteImport } from './routes/_app/insights/runs.$id'
import { Route as AppMeetingTemplatesDefaultsIdRouteImport } from './routes/_app/meeting-templates/defaults.$id'
import { Route as AppMeetingTemplatesDefaultsNewRouteImport } from './routes/_app/meeting-templates/defaults.new'
import { Route as AppOrganisationsIdIndexRouteImport } from './routes/_app/organisations/$id.index'
import { Route as AppOrganisationsIdEditRouteImport } from './routes/_app/organisations/$id.edit'
import { Route as AppSkillsIdIndexRouteImport } from './routes/_app/skills/$id.index'
import { Route as AppSkillsIdEditRouteImport } from './routes/_app/skills/$id.edit'
import { Route as AppTracksIdIndexRouteImport } from './routes/_app/tracks/$id.index'
import { Route as AppTracksIdEditRouteImport } from './routes/_app/tracks/$id.edit'
import { Route as AppUsersIdIndexRouteImport } from './routes/_app/users/$id.index'
import { Route as AppUsersIdEditRouteImport } from './routes/_app/users/$id.edit'
import { Route as AppAdminNotificationsHistoryIndexRouteImport } from './routes/_app/admin/notifications/history.index'
import { Route as AppAdminNotificationsHistorySendIdRouteImport } from './routes/_app/admin/notifications/history.$sendId'
import { Route as AppInsightsRoutinesIdEditRouteImport } from './routes/_app/insights/routines.$id.edit'
import { Route as AppInsightsRoutinesIdRunsRouteImport } from './routes/_app/insights/routines.$id.runs'
import { Route as AppJourneyTypesOrganisationsOrganisationIdIdRouteImport } from './routes/_app/journey-types/organisations.$organisationId.$id'
import { Route as AppJourneysOrganisationsOrganisationIdIdRouteImport } from './routes/_app/journeys/organisations.$organisationId.$id'
import { Route as AppMeetingTemplatesOrganisationsOrganisationIdIdRouteImport } from './routes/_app/meeting-templates/organisations.$organisationId.$id'
import { Route as AppMeetingTemplatesOrganisationsOrganisationIdNewRouteImport } from './routes/_app/meeting-templates/organisations.$organisationId.new'
import { Route as AppAdminRecommendationRunsRunIdUsersUserIdRouteImport } from './routes/_app/admin/recommendation-runs/$runId.users.$userId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const RoleplayRoute = RoleplayRouteImport.update({
  id: '/roleplay',
  path: '/roleplay',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppDemoRoute = AppDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppJourneyTypesRoute = AppJourneyTypesRouteImport.update({
  id: '/journey-types',
  path: '/journey-types',
  getParentRoute: () => AppRoute,
} as any)
const AppJourneysRoute = AppJourneysRouteImport.update({
  id: '/journeys',
  path: '/journeys',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingTemplatesRoute = AppMeetingTemplatesRouteImport.update({
  id: '/meeting-templates',
  path: '/meeting-templates',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppNpsResponsesRoute = AppNpsResponsesRouteImport.update({
  id: '/nps-responses',
  path: '/nps-responses',
  getParentRoute: () => AppRoute,
} as any)
const AppSkillsRoute = AppSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppRoute,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminBrevoRoute = AppAdminBrevoRouteImport.update({
  id: '/brevo',
  path: '/brevo',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminBroadcastRoute = AppAdminBroadcastRouteImport.update({
  id: '/broadcast',
  path: '/broadcast',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminBulkImportRoute = AppAdminBulkImportRouteImport.update({
  id: '/bulk-import',
  path: '/bulk-import',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminChangeLogsRoute = AppAdminChangeLogsRouteImport.update({
  id: '/change-logs',
  path: '/change-logs',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeatureFlagsRoute = AppAdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminMaintenanceRoute = AppAdminMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminMcpRoute = AppAdminMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOutreachQueueRoute = AppAdminOutreachQueueRouteImport.update({
  id: '/outreach-queue',
  path: '/outreach-queue',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminPipelineRoute = AppAdminPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRecommendationsRoute = AppAdminRecommendationsRouteImport.update({
  id: '/recommendations',
  path: '/recommendations',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminScheduledTasksRoute = AppAdminScheduledTasksRouteImport.update({
  id: '/scheduled-tasks',
  path: '/scheduled-tasks',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSkillBroadcastsRoute = AppAdminSkillBroadcastsRouteImport.update({
  id: '/skill-broadcasts',
  path: '/skill-broadcasts',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminStaffMcpRoute = AppAdminStaffMcpRouteImport.update({
  id: '/staff-mcp',
  path: '/staff-mcp',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUnansweredRoute = AppAdminUnansweredRouteImport.update({
  id: '/unanswered',
  path: '/unanswered',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppCohortsIndexRoute = AppCohortsIndexRouteImport.update({
  id: '/cohorts/',
  path: '/cohorts/',
  getParentRoute: () => AppRoute,
} as any)
const AppCohortsCreateRoute = AppCohortsCreateRouteImport.update({
  id: '/cohorts/create',
  path: '/cohorts/create',
  getParentRoute: () => AppRoute,
} as any)
const AppConversationReviewsIndexRoute =
  AppConversationReviewsIndexRouteImport.update({
    id: '/conversation-reviews/',
    path: '/conversation-reviews/',
    getParentRoute: () => AppRoute,
  } as any)
const AppConversationReviewsIdRoute =
  AppConversationReviewsIdRouteImport.update({
    id: '/conversation-reviews/$id',
    path: '/conversation-reviews/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardCostsRoute = AppDashboardCostsRouteImport.update({
  id: '/dashboard/costs',
  path: '/dashboard/costs',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardMetricsHistoryRoute =
  AppDashboardMetricsHistoryRouteImport.update({
    id: '/dashboard/metrics-history',
    path: '/dashboard/metrics-history',
    getParentRoute: () => AppRoute,
  } as any)
const AppDashboardPageUsageRoute = AppDashboardPageUsageRouteImport.update({
  id: '/dashboard/page-usage',
  path: '/dashboard/page-usage',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardQuestionsRoute = AppDashboardQuestionsRouteImport.update({
  id: '/dashboard/questions',
  path: '/dashboard/questions',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsIndexRoute = AppInsightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInsightsRoute,
} as any)
const AppJourneyTypesIndexRoute = AppJourneyTypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppJourneyTypesRoute,
} as any)
const AppJourneyTypesNewRoute = AppJourneyTypesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppJourneyTypesRoute,
} as any)
const AppJourneysIndexRoute = AppJourneysIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppJourneysRoute,
} as any)
const AppJourneysNewRoute = AppJourneysNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppJourneysRoute,
} as any)
const AppMeetingTemplatesIndexRoute =
  AppMeetingTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppMeetingTemplatesRoute,
  } as any)
const AppOrganisationsIndexRoute = AppOrganisationsIndexRouteImport.update({
  id: '/organisations/',
  path: '/organisations/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganisationsCreateRoute = AppOrganisationsCreateRouteImport.update({
  id: '/organisations/create',
  path: '/organisations/create',
  getParentRoute: () => AppRoute,
} as any)
const AppSkillsIndexRoute = AppSkillsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSkillsRoute,
} as any)
const AppSkillsCreateRoute = AppSkillsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppSkillsRoute,
} as any)
const AppTopicsIndexRoute = AppTopicsIndexRouteImport.update({
  id: '/topics/',
  path: '/topics/',
  getParentRoute: () => AppRoute,
} as any)
const AppTopicsIdRoute = AppTopicsIdRouteImport.update({
  id: '/topics/$id',
  path: '/topics/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTracesTraceIdRoute = AppTracesTraceIdRouteImport.update({
  id: '/traces/$traceId',
  path: '/traces/$traceId',
  getParentRoute: () => AppRoute,
} as any)
const AppTracksIndexRoute = AppTracksIndexRouteImport.update({
  id: '/tracks/',
  path: '/tracks/',
  getParentRoute: () => AppRoute,
} as any)
const AppTracksCreateRoute = AppTracksCreateRouteImport.update({
  id: '/tracks/create',
  path: '/tracks/create',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersCreateRoute = AppUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminNotificationsIndexRoute =
  AppAdminNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminRecommendationRunsIndexRoute =
  AppAdminRecommendationRunsIndexRouteImport.update({
    id: '/recommendation-runs/',
    path: '/recommendation-runs/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppCohortsIdIndexRoute = AppCohortsIdIndexRouteImport.update({
  id: '/cohorts/$id/',
  path: '/cohorts/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppCohortsIdEditRoute = AppCohortsIdEditRouteImport.update({
  id: '/cohorts/$id/edit',
  path: '/cohorts/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoutinesNewRoute = AppInsightsRoutinesNewRouteImport.update({
  id: '/routines/new',
  path: '/routines/new',
  getParentRoute: () => AppInsightsRoute,
} as any)
const AppInsightsRunsIdRoute = AppInsightsRunsIdRouteImport.update({
  id: '/runs/$id',
  path: '/runs/$id',
  getParentRoute: () => AppInsightsRoute,
} as any)
const AppMeetingTemplatesDefaultsIdRoute =
  AppMeetingTemplatesDefaultsIdRouteImport.update({
    id: '/defaults/$id',
    path: '/defaults/$id',
    getParentRoute: () => AppMeetingTemplatesRoute,
  } as any)
const AppMeetingTemplatesDefaultsNewRoute =
  AppMeetingTemplatesDefaultsNewRouteImport.update({
    id: '/defaults/new',
    path: '/defaults/new',
    getParentRoute: () => AppMeetingTemplatesRoute,
  } as any)
const AppOrganisationsIdIndexRoute = AppOrganisationsIdIndexRouteImport.update({
  id: '/organisations/$id/',
  path: '/organisations/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganisationsIdEditRoute = AppOrganisationsIdEditRouteImport.update({
  id: '/organisations/$id/edit',
  path: '/organisations/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppSkillsIdIndexRoute = AppSkillsIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AppSkillsRoute,
} as any)
const AppSkillsIdEditRoute = AppSkillsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppSkillsRoute,
} as any)
const AppTracksIdIndexRoute = AppTracksIdIndexRouteImport.update({
  id: '/tracks/$id/',
  path: '/tracks/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppTracksIdEditRoute = AppTracksIdEditRouteImport.update({
  id: '/tracks/$id/edit',
  path: '/tracks/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdIndexRoute = AppUsersIdIndexRouteImport.update({
  id: '/users/$id/',
  path: '/users/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdEditRoute = AppUsersIdEditRouteImport.update({
  id: '/users/$id/edit',
  path: '/users/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminNotificationsHistoryIndexRoute =
  AppAdminNotificationsHistoryIndexRouteImport.update({
    id: '/notifications/history/',
    path: '/notifications/history/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminNotificationsHistorySendIdRoute =
  AppAdminNotificationsHistorySendIdRouteImport.update({
    id: '/notifications/history/$sendId',
    path: '/notifications/history/$sendId',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppInsightsRoutinesIdEditRoute =
  AppInsightsRoutinesIdEditRouteImport.update({
    id: '/routines/$id/edit',
    path: '/routines/$id/edit',
    getParentRoute: () => AppInsightsRoute,
  } as any)
const AppInsightsRoutinesIdRunsRoute =
  AppInsightsRoutinesIdRunsRouteImport.update({
    id: '/routines/$id/runs',
    path: '/routines/$id/runs',
    getParentRoute: () => AppInsightsRoute,
  } as any)
const AppJourneyTypesOrganisationsOrganisationIdIdRoute =
  AppJourneyTypesOrganisationsOrganisationIdIdRouteImport.update({
    id: '/organisations/$organisationId/$id',
    path: '/organisations/$organisationId/$id',
    getParentRoute: () => AppJourneyTypesRoute,
  } as any)
const AppJourneysOrganisationsOrganisationIdIdRoute =
  AppJourneysOrganisationsOrganisationIdIdRouteImport.update({
    id: '/organisations/$organisationId/$id',
    path: '/organisations/$organisationId/$id',
    getParentRoute: () => AppJourneysRoute,
  } as any)
const AppMeetingTemplatesOrganisationsOrganisationIdIdRoute =
  AppMeetingTemplatesOrganisationsOrganisationIdIdRouteImport.update({
    id: '/organisations/$organisationId/$id',
    path: '/organisations/$organisationId/$id',
    getParentRoute: () => AppMeetingTemplatesRoute,
  } as any)
const AppMeetingTemplatesOrganisationsOrganisationIdNewRoute =
  AppMeetingTemplatesOrganisationsOrganisationIdNewRouteImport.update({
    id: '/organisations/$organisationId/new',
    path: '/organisations/$organisationId/new',
    getParentRoute: () => AppMeetingTemplatesRoute,
  } as any)
const AppAdminRecommendationRunsRunIdUsersUserIdRoute =
  AppAdminRecommendationRunsRunIdUsersUserIdRouteImport.update({
    id: '/recommendation-runs/$runId/users/$userId',
    path: '/recommendation-runs/$runId/users/$userId',
    getParentRoute: () => AppAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/connect': typeof ConnectRoute
  '/roleplay': typeof RoleplayRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/demo': typeof AppDemoRoute
  '/documents': typeof AppDocumentsRoute
  '/insights': typeof AppInsightsRouteWithChildren
  '/journey-types': typeof AppJourneyTypesRouteWithChildren
  '/journeys': typeof AppJourneysRouteWithChildren
  '/meeting-templates': typeof AppMeetingTemplatesRouteWithChildren
  '/messages': typeof AppMessagesRoute
  '/nps-responses': typeof AppNpsResponsesRoute
  '/skills': typeof AppSkillsRouteWithChildren
  '/auth/error': typeof AuthErrorRoute
  '/admin/brevo': typeof AppAdminBrevoRoute
  '/admin/broadcast': typeof AppAdminBroadcastRoute
  '/admin/bulk-import': typeof AppAdminBulkImportRoute
  '/admin/change-logs': typeof AppAdminChangeLogsRoute
  '/admin/feature-flags': typeof AppAdminFeatureFlagsRoute
  '/admin/maintenance': typeof AppAdminMaintenanceRoute
  '/admin/mcp': typeof AppAdminMcpRoute
  '/admin/outreach-queue': typeof AppAdminOutreachQueueRoute
  '/admin/pipeline': typeof AppAdminPipelineRoute
  '/admin/recommendations': typeof AppAdminRecommendationsRoute
  '/admin/scheduled-tasks': typeof AppAdminScheduledTasksRoute
  '/admin/skill-broadcasts': typeof AppAdminSkillBroadcastsRoute
  '/admin/staff-mcp': typeof AppAdminStaffMcpRoute
  '/admin/unanswered': typeof AppAdminUnansweredRoute
  '/cohorts/create': typeof AppCohortsCreateRoute
  '/conversation-reviews/$id': typeof AppConversationReviewsIdRoute
  '/dashboard/costs': typeof AppDashboardCostsRoute
  '/dashboard/metrics-history': typeof AppDashboardMetricsHistoryRoute
  '/dashboard/page-usage': typeof AppDashboardPageUsageRoute
  '/dashboard/questions': typeof AppDashboardQuestionsRoute
  '/journey-types/new': typeof AppJourneyTypesNewRoute
  '/journeys/new': typeof AppJourneysNewRoute
  '/organisations/create': typeof AppOrganisationsCreateRoute
  '/skills/create': typeof AppSkillsCreateRoute
  '/topics/$id': typeof AppTopicsIdRoute
  '/traces/$traceId': typeof AppTracesTraceIdRoute
  '/tracks/create': typeof AppTracksCreateRoute
  '/users/create': typeof AppUsersCreateRoute
  '/admin/': typeof AppAdminIndexRoute
  '/cohorts/': typeof AppCohortsIndexRoute
  '/conversation-reviews/': typeof AppConversationReviewsIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/insights/': typeof AppInsightsIndexRoute
  '/journey-types/': typeof AppJourneyTypesIndexRoute
  '/journeys/': typeof AppJourneysIndexRoute
  '/meeting-templates/': typeof AppMeetingTemplatesIndexRoute
  '/organisations/': typeof AppOrganisationsIndexRoute
  '/skills/': typeof AppSkillsIndexRoute
  '/topics/': typeof AppTopicsIndexRoute
  '/tracks/': typeof AppTracksIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/cohorts/$id/edit': typeof AppCohortsIdEditRoute
  '/insights/routines/new': typeof AppInsightsRoutinesNewRoute
  '/insights/runs/$id': typeof AppInsightsRunsIdRoute
  '/meeting-templates/defaults/$id': typeof AppMeetingTemplatesDefaultsIdRoute
  '/meeting-templates/defaults/new': typeof AppMeetingTemplatesDefaultsNewRoute
  '/organisations/$id/edit': typeof AppOrganisationsIdEditRoute
  '/skills/$id/edit': typeof AppSkillsIdEditRoute
  '/tracks/$id/edit': typeof AppTracksIdEditRoute
  '/users/$id/edit': typeof AppUsersIdEditRoute
  '/admin/notifications/': typeof AppAdminNotificationsIndexRoute
  '/admin/recommendation-runs/': typeof AppAdminRecommendationRunsIndexRoute
  '/cohorts/$id/': typeof AppCohortsIdIndexRoute
  '/organisations/$id/': typeof AppOrganisationsIdIndexRoute
  '/skills/$id/': typeof AppSkillsIdIndexRoute
  '/tracks/$id/': typeof AppTracksIdIndexRoute
  '/users/$id/': typeof AppUsersIdIndexRoute
  '/admin/notifications/history/$sendId': typeof AppAdminNotificationsHistorySendIdRoute
  '/insights/routines/$id/edit': typeof AppInsightsRoutinesIdEditRoute
  '/insights/routines/$id/runs': typeof AppInsightsRoutinesIdRunsRoute
  '/journey-types/organisations/$organisationId/$id': typeof AppJourneyTypesOrganisationsOrganisationIdIdRoute
  '/journeys/organisations/$organisationId/$id': typeof AppJourneysOrganisationsOrganisationIdIdRoute
  '/meeting-templates/organisations/$organisationId/$id': typeof AppMeetingTemplatesOrganisationsOrganisationIdIdRoute
  '/meeting-templates/organisations/$organisationId/new': typeof AppMeetingTemplatesOrganisationsOrganisationIdNewRoute
  '/admin/notifications/history/': typeof AppAdminNotificationsHistoryIndexRoute
  '/admin/recommendation-runs/$runId/users/$userId': typeof AppAdminRecommendationRunsRunIdUsersUserIdRoute
}
export interface FileRoutesByTo {
  '/connect': typeof ConnectRoute
  '/roleplay': typeof RoleplayRoute
  '/demo': typeof AppDemoRoute
  '/documents': typeof AppDocumentsRoute
  '/messages': typeof AppMessagesRoute
  '/nps-responses': typeof AppNpsResponsesRoute
  '/auth/error': typeof AuthErrorRoute
  '/': typeof AppIndexRoute
  '/admin/brevo': typeof AppAdminBrevoRoute
  '/admin/broadcast': typeof AppAdminBroadcastRoute
  '/admin/bulk-import': typeof AppAdminBulkImportRoute
  '/admin/change-logs': typeof AppAdminChangeLogsRoute
  '/admin/feature-flags': typeof AppAdminFeatureFlagsRoute
  '/admin/maintenance': typeof AppAdminMaintenanceRoute
  '/admin/mcp': typeof AppAdminMcpRoute
  '/admin/outreach-queue': typeof AppAdminOutreachQueueRoute
  '/admin/pipeline': typeof AppAdminPipelineRoute
  '/admin/recommendations': typeof AppAdminRecommendationsRoute
  '/admin/scheduled-tasks': typeof AppAdminScheduledTasksRoute
  '/admin/skill-broadcasts': typeof AppAdminSkillBroadcastsRoute
  '/admin/staff-mcp': typeof AppAdminStaffMcpRoute
  '/admin/unanswered': typeof AppAdminUnansweredRoute
  '/cohorts/create': typeof AppCohortsCreateRoute
  '/conversation-reviews/$id': typeof AppConversationReviewsIdRoute
  '/dashboard/costs': typeof AppDashboardCostsRoute
  '/dashboard/metrics-history': typeof AppDashboardMetricsHistoryRoute
  '/dashboard/page-usage': typeof AppDashboardPageUsageRoute
  '/dashboard/questions': typeof AppDashboardQuestionsRoute
  '/journey-types/new': typeof AppJourneyTypesNewRoute
  '/journeys/new': typeof AppJourneysNewRoute
  '/organisations/create': typeof AppOrganisationsCreateRoute
  '/skills/create': typeof AppSkillsCreateRoute
  '/topics/$id': typeof AppTopicsIdRoute
  '/traces/$traceId': typeof AppTracesTraceIdRoute
  '/tracks/create': typeof AppTracksCreateRoute
  '/users/create': typeof AppUsersCreateRoute
  '/admin': typeof AppAdminIndexRoute
  '/cohorts': typeof AppCohortsIndexRoute
  '/conversation-reviews': typeof AppConversationReviewsIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/insights': typeof AppInsightsIndexRoute
  '/journey-types': typeof AppJourneyTypesIndexRoute
  '/journeys': typeof AppJourneysIndexRoute
  '/meeting-templates': typeof AppMeetingTemplatesIndexRoute
  '/organisations': typeof AppOrganisationsIndexRoute
  '/skills': typeof AppSkillsIndexRoute
  '/topics': typeof AppTopicsIndexRoute
  '/tracks': typeof AppTracksIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/cohorts/$id/edit': typeof AppCohortsIdEditRoute
  '/insights/routines/new': typeof AppInsightsRoutinesNewRoute
  '/insights/runs/$id': typeof AppInsightsRunsIdRoute
  '/meeting-templates/defaults/$id': typeof AppMeetingTemplatesDefaultsIdRoute
  '/meeting-templates/defaults/new': typeof AppMeetingTemplatesDefaultsNewRoute
  '/organisations/$id/edit': typeof AppOrganisationsIdEditRoute
  '/skills/$id/edit': typeof AppSkillsIdEditRoute
  '/tracks/$id/edit': typeof AppTracksIdEditRoute
  '/users/$id/edit': typeof AppUsersIdEditRoute
  '/admin/notifications': typeof AppAdminNotificationsIndexRoute
  '/admin/recommendation-runs': typeof AppAdminRecommendationRunsIndexRoute
  '/cohorts/$id': typeof AppCohortsIdIndexRoute
  '/organisations/$id': typeof AppOrganisationsIdIndexRoute
  '/skills/$id': typeof AppSkillsIdIndexRoute
  '/tracks/$id': typeof AppTracksIdIndexRoute
  '/users/$id': typeof AppUsersIdIndexRoute
  '/admin/notifications/history/$sendId': typeof AppAdminNotificationsHistorySendIdRoute
  '/insights/routines/$id/edit': typeof AppInsightsRoutinesIdEditRoute
  '/insights/routines/$id/runs': typeof AppInsightsRoutinesIdRunsRoute
  '/journey-types/organisations/$organisationId/$id': typeof AppJourneyTypesOrganisationsOrganisationIdIdRoute
  '/journeys/organisations/$organisationId/$id': typeof AppJourneysOrganisationsOrganisationIdIdRoute
  '/meeting-templates/organisations/$organisationId/$id': typeof AppMeetingTemplatesOrganisationsOrganisationIdIdRoute
  '/meeting-templates/organisations/$organisationId/new': typeof AppMeetingTemplatesOrganisationsOrganisationIdNewRoute
  '/admin/notifications/history': typeof AppAdminNotificationsHistoryIndexRoute
  '/admin/recommendation-runs/$runId/users/$userId': typeof AppAdminRecommendationRunsRunIdUsersUserIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/connect': typeof ConnectRoute
  '/roleplay': typeof RoleplayRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/demo': typeof AppDemoRoute
  '/_app/documents': typeof AppDocumentsRoute
  '/_app/insights': typeof AppInsightsRouteWithChildren
  '/_app/journey-types': typeof AppJourneyTypesRouteWithChildren
  '/_app/journeys': typeof AppJourneysRouteWithChildren
  '/_app/meeting-templates': typeof AppMeetingTemplatesRouteWithChildren
  '/_app/messages': typeof AppMessagesRoute
  '/_app/nps-responses': typeof AppNpsResponsesRoute
  '/_app/skills': typeof AppSkillsRouteWithChildren
  '/auth/error': typeof AuthErrorRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/brevo': typeof AppAdminBrevoRoute
  '/_app/admin/broadcast': typeof AppAdminBroadcastRoute
  '/_app/admin/bulk-import': typeof AppAdminBulkImportRoute
  '/_app/admin/change-logs': typeof AppAdminChangeLogsRoute
  '/_app/admin/feature-flags': typeof AppAdminFeatureFlagsRoute
  '/_app/admin/maintenance': typeof AppAdminMaintenanceRoute
  '/_app/admin/mcp': typeof AppAdminMcpRoute
  '/_app/admin/outreach-queue': typeof AppAdminOutreachQueueRoute
  '/_app/admin/pipeline': typeof AppAdminPipelineRoute
  '/_app/admin/recommendations': typeof AppAdminRecommendationsRoute
  '/_app/admin/scheduled-tasks': typeof AppAdminScheduledTasksRoute
  '/_app/admin/skill-broadcasts': typeof AppAdminSkillBroadcastsRoute
  '/_app/admin/staff-mcp': typeof AppAdminStaffMcpRoute
  '/_app/admin/unanswered': typeof AppAdminUnansweredRoute
  '/_app/cohorts/create': typeof AppCohortsCreateRoute
  '/_app/conversation-reviews/$id': typeof AppConversationReviewsIdRoute
  '/_app/dashboard/costs': typeof AppDashboardCostsRoute
  '/_app/dashboard/metrics-history': typeof AppDashboardMetricsHistoryRoute
  '/_app/dashboard/page-usage': typeof AppDashboardPageUsageRoute
  '/_app/dashboard/questions': typeof AppDashboardQuestionsRoute
  '/_app/journey-types/new': typeof AppJourneyTypesNewRoute
  '/_app/journeys/new': typeof AppJourneysNewRoute
  '/_app/organisations/create': typeof AppOrganisationsCreateRoute
  '/_app/skills/create': typeof AppSkillsCreateRoute
  '/_app/topics/$id': typeof AppTopicsIdRoute
  '/_app/traces/$traceId': typeof AppTracesTraceIdRoute
  '/_app/tracks/create': typeof AppTracksCreateRoute
  '/_app/users/create': typeof AppUsersCreateRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/cohorts/': typeof AppCohortsIndexRoute
  '/_app/conversation-reviews/': typeof AppConversationReviewsIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/insights/': typeof AppInsightsIndexRoute
  '/_app/journey-types/': typeof AppJourneyTypesIndexRoute
  '/_app/journeys/': typeof AppJourneysIndexRoute
  '/_app/meeting-templates/': typeof AppMeetingTemplatesIndexRoute
  '/_app/organisations/': typeof AppOrganisationsIndexRoute
  '/_app/skills/': typeof AppSkillsIndexRoute
  '/_app/topics/': typeof AppTopicsIndexRoute
  '/_app/tracks/': typeof AppTracksIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/cohorts/$id/edit': typeof AppCohortsIdEditRoute
  '/_app/insights/routines/new': typeof AppInsightsRoutinesNewRoute
  '/_app/insights/runs/$id': typeof AppInsightsRunsIdRoute
  '/_app/meeting-templates/defaults/$id': typeof AppMeetingTemplatesDefaultsIdRoute
  '/_app/meeting-templates/defaults/new': typeof AppMeetingTemplatesDefaultsNewRoute
  '/_app/organisations/$id/edit': typeof AppOrganisationsIdEditRoute
  '/_app/skills/$id/edit': typeof AppSkillsIdEditRoute
  '/_app/tracks/$id/edit': typeof AppTracksIdEditRoute
  '/_app/users/$id/edit': typeof AppUsersIdEditRoute
  '/_app/admin/notifications/': typeof AppAdminNotificationsIndexRoute
  '/_app/admin/recommendation-runs/': typeof AppAdminRecommendationRunsIndexRoute
  '/_app/cohorts/$id/': typeof AppCohortsIdIndexRoute
  '/_app/organisations/$id/': typeof AppOrganisationsIdIndexRoute
  '/_app/skills/$id/': typeof AppSkillsIdIndexRoute
  '/_app/tracks/$id/': typeof AppTracksIdIndexRoute
  '/_app/users/$id/': typeof AppUsersIdIndexRoute
  '/_app/admin/notifications/history/$sendId': typeof AppAdminNotificationsHistorySendIdRoute
  '/_app/insights/routines/$id/edit': typeof AppInsightsRoutinesIdEditRoute
  '/_app/insights/routines/$id/runs': typeof AppInsightsRoutinesIdRunsRoute
  '/_app/journey-types/organisations/$organisationId/$id': typeof AppJourneyTypesOrganisationsOrganisationIdIdRoute
  '/_app/journeys/organisations/$organisationId/$id': typeof AppJourneysOrganisationsOrganisationIdIdRoute
  '/_app/meeting-templates/organisations/$organisationId/$id': typeof AppMeetingTemplatesOrganisationsOrganisationIdIdRoute
  '/_app/meeting-templates/organisations/$organisationId/new': typeof AppMeetingTemplatesOrganisationsOrganisationIdNewRoute
  '/_app/admin/notifications/history/': typeof AppAdminNotificationsHistoryIndexRoute
  '/_app/admin/recommendation-runs/$runId/users/$userId': typeof AppAdminRecommendationRunsRunIdUsersUserIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/roleplay'
    | '/admin'
    | '/demo'
    | '/documents'
    | '/insights'
    | '/journey-types'
    | '/journeys'
    | '/meeting-templates'
    | '/messages'
    | '/nps-responses'
    | '/skills'
    | '/auth/error'
    | '/admin/brevo'
    | '/admin/broadcast'
    | '/admin/bulk-import'
    | '/admin/change-logs'
    | '/admin/feature-flags'
    | '/admin/maintenance'
    | '/admin/mcp'
    | '/admin/outreach-queue'
    | '/admin/pipeline'
    | '/admin/recommendations'
    | '/admin/scheduled-tasks'
    | '/admin/skill-broadcasts'
    | '/admin/staff-mcp'
    | '/admin/unanswered'
    | '/cohorts/create'
    | '/conversation-reviews/$id'
    | '/dashboard/costs'
    | '/dashboard/metrics-history'
    | '/dashboard/page-usage'
    | '/dashboard/questions'
    | '/journey-types/new'
    | '/journeys/new'
    | '/organisations/create'
    | '/skills/create'
    | '/topics/$id'
    | '/traces/$traceId'
    | '/tracks/create'
    | '/users/create'
    | '/admin/'
    | '/cohorts/'
    | '/conversation-reviews/'
    | '/dashboard/'
    | '/insights/'
    | '/journey-types/'
    | '/journeys/'
    | '/meeting-templates/'
    | '/organisations/'
    | '/skills/'
    | '/topics/'
    | '/tracks/'
    | '/users/'
    | '/cohorts/$id/edit'
    | '/insights/routines/new'
    | '/insights/runs/$id'
    | '/meeting-templates/defaults/$id'
    | '/meeting-templates/defaults/new'
    | '/organisations/$id/edit'
    | '/skills/$id/edit'
    | '/tracks/$id/edit'
    | '/users/$id/edit'
    | '/admin/notifications/'
    | '/admin/recommendation-runs/'
    | '/cohorts/$id/'
    | '/organisations/$id/'
    | '/skills/$id/'
    | '/tracks/$id/'
    | '/users/$id/'
    | '/admin/notifications/history/$sendId'
    | '/insights/routines/$id/edit'
    | '/insights/routines/$id/runs'
    | '/journey-types/organisations/$organisationId/$id'
    | '/journeys/organisations/$organisationId/$id'
    | '/meeting-templates/organisations/$organisationId/$id'
    | '/meeting-templates/organisations/$organisationId/new'
    | '/admin/notifications/history/'
    | '/admin/recommendation-runs/$runId/users/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connect'
    | '/roleplay'
    | '/demo'
    | '/documents'
    | '/messages'
    | '/nps-responses'
    | '/auth/error'
    | '/'
    | '/admin/brevo'
    | '/admin/broadcast'
    | '/admin/bulk-import'
    | '/admin/change-logs'
    | '/admin/feature-flags'
    | '/admin/maintenance'
    | '/admin/mcp'
    | '/admin/outreach-queue'
    | '/admin/pipeline'
    | '/admin/recommendations'
    | '/admin/scheduled-tasks'
    | '/admin/skill-broadcasts'
    | '/admin/staff-mcp'
    | '/admin/unanswered'
    | '/cohorts/create'
    | '/conversation-reviews/$id'
    | '/dashboard/costs'
    | '/dashboard/metrics-history'
    | '/dashboard/page-usage'
    | '/dashboard/questions'
    | '/journey-types/new'
    | '/journeys/new'
    | '/organisations/create'
    | '/skills/create'
    | '/topics/$id'
    | '/traces/$traceId'
    | '/tracks/create'
    | '/users/create'
    | '/admin'
    | '/cohorts'
    | '/conversation-reviews'
    | '/dashboard'
    | '/insights'
    | '/journey-types'
    | '/journeys'
    | '/meeting-templates'
    | '/organisations'
    | '/skills'
    | '/topics'
    | '/tracks'
    | '/users'
    | '/cohorts/$id/edit'
    | '/insights/routines/new'
    | '/insights/runs/$id'
    | '/meeting-templates/defaults/$id'
    | '/meeting-templates/defaults/new'
    | '/organisations/$id/edit'
    | '/skills/$id/edit'
    | '/tracks/$id/edit'
    | '/users/$id/edit'
    | '/admin/notifications'
    | '/admin/recommendation-runs'
    | '/cohorts/$id'
    | '/organisations/$id'
    | '/skills/$id'
    | '/tracks/$id'
    | '/users/$id'
    | '/admin/notifications/history/$sendId'
    | '/insights/routines/$id/edit'
    | '/insights/routines/$id/runs'
    | '/journey-types/organisations/$organisationId/$id'
    | '/journeys/organisations/$organisationId/$id'
    | '/meeting-templates/organisations/$organisationId/$id'
    | '/meeting-templates/organisations/$organisationId/new'
    | '/admin/notifications/history'
    | '/admin/recommendation-runs/$runId/users/$userId'
  id:
    | '__root__'
    | '/_app'
    | '/connect'
    | '/roleplay'
    | '/_app/admin'
    | '/_app/demo'
    | '/_app/documents'
    | '/_app/insights'
    | '/_app/journey-types'
    | '/_app/journeys'
    | '/_app/meeting-templates'
    | '/_app/messages'
    | '/_app/nps-responses'
    | '/_app/skills'
    | '/auth/error'
    | '/_app/'
    | '/_app/admin/brevo'
    | '/_app/admin/broadcast'
    | '/_app/admin/bulk-import'
    | '/_app/admin/change-logs'
    | '/_app/admin/feature-flags'
    | '/_app/admin/maintenance'
    | '/_app/admin/mcp'
    | '/_app/admin/outreach-queue'
    | '/_app/admin/pipeline'
    | '/_app/admin/recommendations'
    | '/_app/admin/scheduled-tasks'
    | '/_app/admin/skill-broadcasts'
    | '/_app/admin/staff-mcp'
    | '/_app/admin/unanswered'
    | '/_app/cohorts/create'
    | '/_app/conversation-reviews/$id'
    | '/_app/dashboard/costs'
    | '/_app/dashboard/metrics-history'
    | '/_app/dashboard/page-usage'
    | '/_app/dashboard/questions'
    | '/_app/journey-types/new'
    | '/_app/journeys/new'
    | '/_app/organisations/create'
    | '/_app/skills/create'
    | '/_app/topics/$id'
    | '/_app/traces/$traceId'
    | '/_app/tracks/create'
    | '/_app/users/create'
    | '/_app/admin/'
    | '/_app/cohorts/'
    | '/_app/conversation-reviews/'
    | '/_app/dashboard/'
    | '/_app/insights/'
    | '/_app/journey-types/'
    | '/_app/journeys/'
    | '/_app/meeting-templates/'
    | '/_app/organisations/'
    | '/_app/skills/'
    | '/_app/topics/'
    | '/_app/tracks/'
    | '/_app/users/'
    | '/_app/cohorts/$id/edit'
    | '/_app/insights/routines/new'
    | '/_app/insights/runs/$id'
    | '/_app/meeting-templates/defaults/$id'
    | '/_app/meeting-templates/defaults/new'
    | '/_app/organisations/$id/edit'
    | '/_app/skills/$id/edit'
    | '/_app/tracks/$id/edit'
    | '/_app/users/$id/edit'
    | '/_app/admin/notifications/'
    | '/_app/admin/recommendation-runs/'
    | '/_app/cohorts/$id/'
    | '/_app/organisations/$id/'
    | '/_app/skills/$id/'
    | '/_app/tracks/$id/'
    | '/_app/users/$id/'
    | '/_app/admin/notifications/history/$sendId'
    | '/_app/insights/routines/$id/edit'
    | '/_app/insights/routines/$id/runs'
    | '/_app/journey-types/organisations/$organisationId/$id'
    | '/_app/journeys/organisations/$organisationId/$id'
    | '/_app/meeting-templates/organisations/$organisationId/$id'
    | '/_app/meeting-templates/organisations/$organisationId/new'
    | '/_app/admin/notifications/history/'
    | '/_app/admin/recommendation-runs/$runId/users/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ConnectRoute: typeof ConnectRoute
  RoleplayRoute: typeof RoleplayRoute
  AuthErrorRoute: typeof AuthErrorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roleplay': {
      id: '/roleplay'
      path: '/roleplay'
      fullPath: '/roleplay'
      preLoaderRoute: typeof RoleplayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/demo': {
      id: '/_app/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof AppDemoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents': {
      id: '/_app/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/journey-types': {
      id: '/_app/journey-types'
      path: '/journey-types'
      fullPath: '/journey-types'
      preLoaderRoute: typeof AppJourneyTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/journeys': {
      id: '/_app/journeys'
      path: '/journeys'
      fullPath: '/journeys'
      preLoaderRoute: typeof AppJourneysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meeting-templates': {
      id: '/_app/meeting-templates'
      path: '/meeting-templates'
      fullPath: '/meeting-templates'
      preLoaderRoute: typeof AppMeetingTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nps-responses': {
      id: '/_app/nps-responses'
      path: '/nps-responses'
      fullPath: '/nps-responses'
      preLoaderRoute: typeof AppNpsResponsesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/skills': {
      id: '/_app/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AppSkillsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/brevo': {
      id: '/_app/admin/brevo'
      path: '/brevo'
      fullPath: '/admin/brevo'
      preLoaderRoute: typeof AppAdminBrevoRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/broadcast': {
      id: '/_app/admin/broadcast'
      path: '/broadcast'
      fullPath: '/admin/broadcast'
      preLoaderRoute: typeof AppAdminBroadcastRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/bulk-import': {
      id: '/_app/admin/bulk-import'
      path: '/bulk-import'
      fullPath: '/admin/bulk-import'
      preLoaderRoute: typeof AppAdminBulkImportRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/change-logs': {
      id: '/_app/admin/change-logs'
      path: '/change-logs'
      fullPath: '/admin/change-logs'
      preLoaderRoute: typeof AppAdminChangeLogsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/feature-flags': {
      id: '/_app/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AppAdminFeatureFlagsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/maintenance': {
      id: '/_app/admin/maintenance'
      path: '/maintenance'
      fullPath: '/admin/maintenance'
      preLoaderRoute: typeof AppAdminMaintenanceRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/mcp': {
      id: '/_app/admin/mcp'
      path: '/mcp'
      fullPath: '/admin/mcp'
      preLoaderRoute: typeof AppAdminMcpRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/outreach-queue': {
      id: '/_app/admin/outreach-queue'
      path: '/outreach-queue'
      fullPath: '/admin/outreach-queue'
      preLoaderRoute: typeof AppAdminOutreachQueueRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/pipeline': {
      id: '/_app/admin/pipeline'
      path: '/pipeline'
      fullPath: '/admin/pipeline'
      preLoaderRoute: typeof AppAdminPipelineRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/recommendations': {
      id: '/_app/admin/recommendations'
      path: '/recommendations'
      fullPath: '/admin/recommendations'
      preLoaderRoute: typeof AppAdminRecommendationsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/scheduled-tasks': {
      id: '/_app/admin/scheduled-tasks'
      path: '/scheduled-tasks'
      fullPath: '/admin/scheduled-tasks'
      preLoaderRoute: typeof AppAdminScheduledTasksRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/skill-broadcasts': {
      id: '/_app/admin/skill-broadcasts'
      path: '/skill-broadcasts'
      fullPath: '/admin/skill-broadcasts'
      preLoaderRoute: typeof AppAdminSkillBroadcastsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/staff-mcp': {
      id: '/_app/admin/staff-mcp'
      path: '/staff-mcp'
      fullPath: '/admin/staff-mcp'
      preLoaderRoute: typeof AppAdminStaffMcpRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/unanswered': {
      id: '/_app/admin/unanswered'
      path: '/unanswered'
      fullPath: '/admin/unanswered'
      preLoaderRoute: typeof AppAdminUnansweredRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/cohorts/': {
      id: '/_app/cohorts/'
      path: '/cohorts'
      fullPath: '/cohorts/'
      preLoaderRoute: typeof AppCohortsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cohorts/create': {
      id: '/_app/cohorts/create'
      path: '/cohorts/create'
      fullPath: '/cohorts/create'
      preLoaderRoute: typeof AppCohortsCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conversation-reviews/': {
      id: '/_app/conversation-reviews/'
      path: '/conversation-reviews'
      fullPath: '/conversation-reviews/'
      preLoaderRoute: typeof AppConversationReviewsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conversation-reviews/$id': {
      id: '/_app/conversation-reviews/$id'
      path: '/conversation-reviews/$id'
      fullPath: '/conversation-reviews/$id'
      preLoaderRoute: typeof AppConversationReviewsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/costs': {
      id: '/_app/dashboard/costs'
      path: '/dashboard/costs'
      fullPath: '/dashboard/costs'
      preLoaderRoute: typeof AppDashboardCostsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/metrics-history': {
      id: '/_app/dashboard/metrics-history'
      path: '/dashboard/metrics-history'
      fullPath: '/dashboard/metrics-history'
      preLoaderRoute: typeof AppDashboardMetricsHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/page-usage': {
      id: '/_app/dashboard/page-usage'
      path: '/dashboard/page-usage'
      fullPath: '/dashboard/page-usage'
      preLoaderRoute: typeof AppDashboardPageUsageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/questions': {
      id: '/_app/dashboard/questions'
      path: '/dashboard/questions'
      fullPath: '/dashboard/questions'
      preLoaderRoute: typeof AppDashboardQuestionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights/': {
      id: '/_app/insights/'
      path: '/'
      fullPath: '/insights/'
      preLoaderRoute: typeof AppInsightsIndexRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/journey-types/': {
      id: '/_app/journey-types/'
      path: '/'
      fullPath: '/journey-types/'
      preLoaderRoute: typeof AppJourneyTypesIndexRouteImport
      parentRoute: typeof AppJourneyTypesRoute
    }
    '/_app/journey-types/new': {
      id: '/_app/journey-types/new'
      path: '/new'
      fullPath: '/journey-types/new'
      preLoaderRoute: typeof AppJourneyTypesNewRouteImport
      parentRoute: typeof AppJourneyTypesRoute
    }
    '/_app/journeys/': {
      id: '/_app/journeys/'
      path: '/'
      fullPath: '/journeys/'
      preLoaderRoute: typeof AppJourneysIndexRouteImport
      parentRoute: typeof AppJourneysRoute
    }
    '/_app/journeys/new': {
      id: '/_app/journeys/new'
      path: '/new'
      fullPath: '/journeys/new'
      preLoaderRoute: typeof AppJourneysNewRouteImport
      parentRoute: typeof AppJourneysRoute
    }
    '/_app/meeting-templates/': {
      id: '/_app/meeting-templates/'
      path: '/'
      fullPath: '/meeting-templates/'
      preLoaderRoute: typeof AppMeetingTemplatesIndexRouteImport
      parentRoute: typeof AppMeetingTemplatesRoute
    }
    '/_app/organisations/': {
      id: '/_app/organisations/'
      path: '/organisations'
      fullPath: '/organisations/'
      preLoaderRoute: typeof AppOrganisationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organisations/create': {
      id: '/_app/organisations/create'
      path: '/organisations/create'
      fullPath: '/organisations/create'
      preLoaderRoute: typeof AppOrganisationsCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/skills/': {
      id: '/_app/skills/'
      path: '/'
      fullPath: '/skills/'
      preLoaderRoute: typeof AppSkillsIndexRouteImport
      parentRoute: typeof AppSkillsRoute
    }
    '/_app/skills/create': {
      id: '/_app/skills/create'
      path: '/create'
      fullPath: '/skills/create'
      preLoaderRoute: typeof AppSkillsCreateRouteImport
      parentRoute: typeof AppSkillsRoute
    }
    '/_app/topics/': {
      id: '/_app/topics/'
      path: '/topics'
      fullPath: '/topics/'
      preLoaderRoute: typeof AppTopicsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/topics/$id': {
      id: '/_app/topics/$id'
      path: '/topics/$id'
      fullPath: '/topics/$id'
      preLoaderRoute: typeof AppTopicsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traces/$traceId': {
      id: '/_app/traces/$traceId'
      path: '/traces/$traceId'
      fullPath: '/traces/$traceId'
      preLoaderRoute: typeof AppTracesTraceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tracks/': {
      id: '/_app/tracks/'
      path: '/tracks'
      fullPath: '/tracks/'
      preLoaderRoute: typeof AppTracksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tracks/create': {
      id: '/_app/tracks/create'
      path: '/tracks/create'
      fullPath: '/tracks/create'
      preLoaderRoute: typeof AppTracksCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/create': {
      id: '/_app/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof AppUsersCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/notifications/': {
      id: '/_app/admin/notifications/'
      path: '/notifications'
      fullPath: '/admin/notifications/'
      preLoaderRoute: typeof AppAdminNotificationsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/recommendation-runs/': {
      id: '/_app/admin/recommendation-runs/'
      path: '/recommendation-runs'
      fullPath: '/admin/recommendation-runs/'
      preLoaderRoute: typeof AppAdminRecommendationRunsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/cohorts/$id/': {
      id: '/_app/cohorts/$id/'
      path: '/cohorts/$id'
      fullPath: '/cohorts/$id/'
      preLoaderRoute: typeof AppCohortsIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cohorts/$id/edit': {
      id: '/_app/cohorts/$id/edit'
      path: '/cohorts/$id/edit'
      fullPath: '/cohorts/$id/edit'
      preLoaderRoute: typeof AppCohortsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights/routines/new': {
      id: '/_app/insights/routines/new'
      path: '/routines/new'
      fullPath: '/insights/routines/new'
      preLoaderRoute: typeof AppInsightsRoutinesNewRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/insights/runs/$id': {
      id: '/_app/insights/runs/$id'
      path: '/runs/$id'
      fullPath: '/insights/runs/$id'
      preLoaderRoute: typeof AppInsightsRunsIdRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/meeting-templates/defaults/$id': {
      id: '/_app/meeting-templates/defaults/$id'
      path: '/defaults/$id'
      fullPath: '/meeting-templates/defaults/$id'
      preLoaderRoute: typeof AppMeetingTemplatesDefaultsIdRouteImport
      parentRoute: typeof AppMeetingTemplatesRoute
    }
    '/_app/meeting-templates/defaults/new': {
      id: '/_app/meeting-templates/defaults/new'
      path: '/defaults/new'
      fullPath: '/meeting-templates/defaults/new'
      preLoaderRoute: typeof AppMeetingTemplatesDefaultsNewRouteImport
      parentRoute: typeof AppMeetingTemplatesRoute
    }
    '/_app/organisations/$id/': {
      id: '/_app/organisations/$id/'
      path: '/organisations/$id'
      fullPath: '/organisations/$id/'
      preLoaderRoute: typeof AppOrganisationsIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organisations/$id/edit': {
      id: '/_app/organisations/$id/edit'
      path: '/organisations/$id/edit'
      fullPath: '/organisations/$id/edit'
      preLoaderRoute: typeof AppOrganisationsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/skills/$id/': {
      id: '/_app/skills/$id/'
      path: '/$id'
      fullPath: '/skills/$id/'
      preLoaderRoute: typeof AppSkillsIdIndexRouteImport
      parentRoute: typeof AppSkillsRoute
    }
    '/_app/skills/$id/edit': {
      id: '/_app/skills/$id/edit'
      path: '/$id/edit'
      fullPath: '/skills/$id/edit'
      preLoaderRoute: typeof AppSkillsIdEditRouteImport
      parentRoute: typeof AppSkillsRoute
    }
    '/_app/tracks/$id/': {
      id: '/_app/tracks/$id/'
      path: '/tracks/$id'
      fullPath: '/tracks/$id/'
      preLoaderRoute: typeof AppTracksIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tracks/$id/edit': {
      id: '/_app/tracks/$id/edit'
      path: '/tracks/$id/edit'
      fullPath: '/tracks/$id/edit'
      preLoaderRoute: typeof AppTracksIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id/': {
      id: '/_app/users/$id/'
      path: '/users/$id'
      fullPath: '/users/$id/'
      preLoaderRoute: typeof AppUsersIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id/edit': {
      id: '/_app/users/$id/edit'
      path: '/users/$id/edit'
      fullPath: '/users/$id/edit'
      preLoaderRoute: typeof AppUsersIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/notifications/history/': {
      id: '/_app/admin/notifications/history/'
      path: '/notifications/history'
      fullPath: '/admin/notifications/history/'
      preLoaderRoute: typeof AppAdminNotificationsHistoryIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/notifications/history/$sendId': {
      id: '/_app/admin/notifications/history/$sendId'
      path: '/notifications/history/$sendId'
      fullPath: '/admin/notifications/history/$sendId'
      preLoaderRoute: typeof AppAdminNotificationsHistorySendIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/insights/routines/$id/edit': {
      id: '/_app/insights/routines/$id/edit'
      path: '/routines/$id/edit'
      fullPath: '/insights/routines/$id/edit'
      preLoaderRoute: typeof AppInsightsRoutinesIdEditRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/insights/routines/$id/runs': {
      id: '/_app/insights/routines/$id/runs'
      path: '/routines/$id/runs'
      fullPath: '/insights/routines/$id/runs'
      preLoaderRoute: typeof AppInsightsRoutinesIdRunsRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/journey-types/organisations/$organisationId/$id': {
      id: '/_app/journey-types/organisations/$organisationId/$id'
      path: '/organisations/$organisationId/$id'
      fullPath: '/journey-types/organisations/$organisationId/$id'
      preLoaderRoute: typeof AppJourneyTypesOrganisationsOrganisationIdIdRouteImport
      parentRoute: typeof AppJourneyTypesRoute
    }
    '/_app/journeys/organisations/$organisationId/$id': {
      id: '/_app/journeys/organisations/$organisationId/$id'
      path: '/organisations/$organisationId/$id'
      fullPath: '/journeys/organisations/$organisationId/$id'
      preLoaderRoute: typeof AppJourneysOrganisationsOrganisationIdIdRouteImport
      parentRoute: typeof AppJourneysRoute
    }
    '/_app/meeting-templates/organisations/$organisationId/$id': {
      id: '/_app/meeting-templates/organisations/$organisationId/$id'
      path: '/organisations/$organisationId/$id'
      fullPath: '/meeting-templates/organisations/$organisationId/$id'
      preLoaderRoute: typeof AppMeetingTemplatesOrganisationsOrganisationIdIdRouteImport
      parentRoute: typeof AppMeetingTemplatesRoute
    }
    '/_app/meeting-templates/organisations/$organisationId/new': {
      id: '/_app/meeting-templates/organisations/$organisationId/new'
      path: '/organisations/$organisationId/new'
      fullPath: '/meeting-templates/organisations/$organisationId/new'
      preLoaderRoute: typeof AppMeetingTemplatesOrganisationsOrganisationIdNewRouteImport
      parentRoute: typeof AppMeetingTemplatesRoute
    }
    '/_app/admin/recommendation-runs/$runId/users/$userId': {
      id: '/_app/admin/recommendation-runs/$runId/users/$userId'
      path: '/recommendation-runs/$runId/users/$userId'
      fullPath: '/admin/recommendation-runs/$runId/users/$userId'
      preLoaderRoute: typeof AppAdminRecommendationRunsRunIdUsersUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminBrevoRoute: typeof AppAdminBrevoRoute
  AppAdminBroadcastRoute: typeof AppAdminBroadcastRoute
  AppAdminBulkImportRoute: typeof AppAdminBulkImportRoute
  AppAdminChangeLogsRoute: typeof AppAdminChangeLogsRoute
  AppAdminFeatureFlagsRoute: typeof AppAdminFeatureFlagsRoute
  AppAdminMaintenanceRoute: typeof AppAdminMaintenanceRoute
  AppAdminMcpRoute: typeof AppAdminMcpRoute
  AppAdminOutreachQueueRoute: typeof AppAdminOutreachQueueRoute
  AppAdminPipelineRoute: typeof AppAdminPipelineRoute
  AppAdminRecommendationsRoute: typeof AppAdminRecommendationsRoute
  AppAdminScheduledTasksRoute: typeof AppAdminScheduledTasksRoute
  AppAdminSkillBroadcastsRoute: typeof AppAdminSkillBroadcastsRoute
  AppAdminStaffMcpRoute: typeof AppAdminStaffMcpRoute
  AppAdminUnansweredRoute: typeof AppAdminUnansweredRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminNotificationsIndexRoute: typeof AppAdminNotificationsIndexRoute
  AppAdminRecommendationRunsIndexRoute: typeof AppAdminRecommendationRunsIndexRoute
  AppAdminNotificationsHistorySendIdRoute: typeof AppAdminNotificationsHistorySendIdRoute
  AppAdminNotificationsHistoryIndexRoute: typeof AppAdminNotificationsHistoryIndexRoute
  AppAdminRecommendationRunsRunIdUsersUserIdRoute: typeof AppAdminRecommendationRunsRunIdUsersUserIdRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminBrevoRoute: AppAdminBrevoRoute,
  AppAdminBroadcastRoute: AppAdminBroadcastRoute,
  AppAdminBulkImportRoute: AppAdminBulkImportRoute,
  AppAdminChangeLogsRoute: AppAdminChangeLogsRoute,
  AppAdminFeatureFlagsRoute: AppAdminFeatureFlagsRoute,
  AppAdminMaintenanceRoute: AppAdminMaintenanceRoute,
  AppAdminMcpRoute: AppAdminMcpRoute,
  AppAdminOutreachQueueRoute: AppAdminOutreachQueueRoute,
  AppAdminPipelineRoute: AppAdminPipelineRoute,
  AppAdminRecommendationsRoute: AppAdminRecommendationsRoute,
  AppAdminScheduledTasksRoute: AppAdminScheduledTasksRoute,
  AppAdminSkillBroadcastsRoute: AppAdminSkillBroadcastsRoute,
  AppAdminStaffMcpRoute: AppAdminStaffMcpRoute,
  AppAdminUnansweredRoute: AppAdminUnansweredRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminNotificationsIndexRoute: AppAdminNotificationsIndexRoute,
  AppAdminRecommendationRunsIndexRoute: AppAdminRecommendationRunsIndexRoute,
  AppAdminNotificationsHistorySendIdRoute:
    AppAdminNotificationsHistorySendIdRoute,
  AppAdminNotificationsHistoryIndexRoute:
    AppAdminNotificationsHistoryIndexRoute,
  AppAdminRecommendationRunsRunIdUsersUserIdRoute:
    AppAdminRecommendationRunsRunIdUsersUserIdRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppInsightsRouteChildren {
  AppInsightsIndexRoute: typeof AppInsightsIndexRoute
  AppInsightsRoutinesNewRoute: typeof AppInsightsRoutinesNewRoute
  AppInsightsRunsIdRoute: typeof AppInsightsRunsIdRoute
  AppInsightsRoutinesIdEditRoute: typeof AppInsightsRoutinesIdEditRoute
  AppInsightsRoutinesIdRunsRoute: typeof AppInsightsRoutinesIdRunsRoute
}

const AppInsightsRouteChildren: AppInsightsRouteChildren = {
  AppInsightsIndexRoute: AppInsightsIndexRoute,
  AppInsightsRoutinesNewRoute: AppInsightsRoutinesNewRoute,
  AppInsightsRunsIdRoute: AppInsightsRunsIdRoute,
  AppInsightsRoutinesIdEditRoute: AppInsightsRoutinesIdEditRoute,
  AppInsightsRoutinesIdRunsRoute: AppInsightsRoutinesIdRunsRoute,
}

const AppInsightsRouteWithChildren = AppInsightsRoute._addFileChildren(
  AppInsightsRouteChildren,
)

interface AppJourneyTypesRouteChildren {
  AppJourneyTypesNewRoute: typeof AppJourneyTypesNewRoute
  AppJourneyTypesIndexRoute: typeof AppJourneyTypesIndexRoute
  AppJourneyTypesOrganisationsOrganisationIdIdRoute: typeof AppJourneyTypesOrganisationsOrganisationIdIdRoute
}

const AppJourneyTypesRouteChildren: AppJourneyTypesRouteChildren = {
  AppJourneyTypesNewRoute: AppJourneyTypesNewRoute,
  AppJourneyTypesIndexRoute: AppJourneyTypesIndexRoute,
  AppJourneyTypesOrganisationsOrganisationIdIdRoute:
    AppJourneyTypesOrganisationsOrganisationIdIdRoute,
}

const AppJourneyTypesRouteWithChildren = AppJourneyTypesRoute._addFileChildren(
  AppJourneyTypesRouteChildren,
)

interface AppJourneysRouteChildren {
  AppJourneysNewRoute: typeof AppJourneysNewRoute
  AppJourneysIndexRoute: typeof AppJourneysIndexRoute
  AppJourneysOrganisationsOrganisationIdIdRoute: typeof AppJourneysOrganisationsOrganisationIdIdRoute
}

const AppJourneysRouteChildren: AppJourneysRouteChildren = {
  AppJourneysNewRoute: AppJourneysNewRoute,
  AppJourneysIndexRoute: AppJourneysIndexRoute,
  AppJourneysOrganisationsOrganisationIdIdRoute:
    AppJourneysOrganisationsOrganisationIdIdRoute,
}

const AppJourneysRouteWithChildren = AppJourneysRoute._addFileChildren(
  AppJourneysRouteChildren,
)

interface AppMeetingTemplatesRouteChildren {
  AppMeetingTemplatesIndexRoute: typeof AppMeetingTemplatesIndexRoute
  AppMeetingTemplatesDefaultsIdRoute: typeof AppMeetingTemplatesDefaultsIdRoute
  AppMeetingTemplatesDefaultsNewRoute: typeof AppMeetingTemplatesDefaultsNewRoute
  AppMeetingTemplatesOrganisationsOrganisationIdIdRoute: typeof AppMeetingTemplatesOrganisationsOrganisationIdIdRoute
  AppMeetingTemplatesOrganisationsOrganisationIdNewRoute: typeof AppMeetingTemplatesOrganisationsOrganisationIdNewRoute
}

const AppMeetingTemplatesRouteChildren: AppMeetingTemplatesRouteChildren = {
  AppMeetingTemplatesIndexRoute: AppMeetingTemplatesIndexRoute,
  AppMeetingTemplatesDefaultsIdRoute: AppMeetingTemplatesDefaultsIdRoute,
  AppMeetingTemplatesDefaultsNewRoute: AppMeetingTemplatesDefaultsNewRoute,
  AppMeetingTemplatesOrganisationsOrganisationIdIdRoute:
    AppMeetingTemplatesOrganisationsOrganisationIdIdRoute,
  AppMeetingTemplatesOrganisationsOrganisationIdNewRoute:
    AppMeetingTemplatesOrganisationsOrganisationIdNewRoute,
}

const AppMeetingTemplatesRouteWithChildren =
  AppMeetingTemplatesRoute._addFileChildren(AppMeetingTemplatesRouteChildren)

interface AppSkillsRouteChildren {
  AppSkillsCreateRoute: typeof AppSkillsCreateRoute
  AppSkillsIndexRoute: typeof AppSkillsIndexRoute
  AppSkillsIdEditRoute: typeof AppSkillsIdEditRoute
  AppSkillsIdIndexRoute: typeof AppSkillsIdIndexRoute
}

const AppSkillsRouteChildren: AppSkillsRouteChildren = {
  AppSkillsCreateRoute: AppSkillsCreateRoute,
  AppSkillsIndexRoute: AppSkillsIndexRoute,
  AppSkillsIdEditRoute: AppSkillsIdEditRoute,
  AppSkillsIdIndexRoute: AppSkillsIdIndexRoute,
}

const AppSkillsRouteWithChildren = AppSkillsRoute._addFileChildren(
  AppSkillsRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppDemoRoute: typeof AppDemoRoute
  AppDocumentsRoute: typeof AppDocumentsRoute
  AppInsightsRoute: typeof AppInsightsRouteWithChildren
  AppJourneyTypesRoute: typeof AppJourneyTypesRouteWithChildren
  AppJourneysRoute: typeof AppJourneysRouteWithChildren
  AppMeetingTemplatesRoute: typeof AppMeetingTemplatesRouteWithChildren
  AppMessagesRoute: typeof AppMessagesRoute
  AppNpsResponsesRoute: typeof AppNpsResponsesRoute
  AppSkillsRoute: typeof AppSkillsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCohortsCreateRoute: typeof AppCohortsCreateRoute
  AppConversationReviewsIdRoute: typeof AppConversationReviewsIdRoute
  AppDashboardCostsRoute: typeof AppDashboardCostsRoute
  AppDashboardMetricsHistoryRoute: typeof AppDashboardMetricsHistoryRoute
  AppDashboardPageUsageRoute: typeof AppDashboardPageUsageRoute
  AppDashboardQuestionsRoute: typeof AppDashboardQuestionsRoute
  AppOrganisationsCreateRoute: typeof AppOrganisationsCreateRoute
  AppTopicsIdRoute: typeof AppTopicsIdRoute
  AppTracesTraceIdRoute: typeof AppTracesTraceIdRoute
  AppTracksCreateRoute: typeof AppTracksCreateRoute
  AppUsersCreateRoute: typeof AppUsersCreateRoute
  AppCohortsIndexRoute: typeof AppCohortsIndexRoute
  AppConversationReviewsIndexRoute: typeof AppConversationReviewsIndexRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppOrganisationsIndexRoute: typeof AppOrganisationsIndexRoute
  AppTopicsIndexRoute: typeof AppTopicsIndexRoute
  AppTracksIndexRoute: typeof AppTracksIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppCohortsIdEditRoute: typeof AppCohortsIdEditRoute
  AppOrganisationsIdEditRoute: typeof AppOrganisationsIdEditRoute
  AppTracksIdEditRoute: typeof AppTracksIdEditRoute
  AppUsersIdEditRoute: typeof AppUsersIdEditRoute
  AppCohortsIdIndexRoute: typeof AppCohortsIdIndexRoute
  AppOrganisationsIdIndexRoute: typeof AppOrganisationsIdIndexRoute
  AppTracksIdIndexRoute: typeof AppTracksIdIndexRoute
  AppUsersIdIndexRoute: typeof AppUsersIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDemoRoute: AppDemoRoute,
  AppDocumentsRoute: AppDocumentsRoute,
  AppInsightsRoute: AppInsightsRouteWithChildren,
  AppJourneyTypesRoute: AppJourneyTypesRouteWithChildren,
  AppJourneysRoute: AppJourneysRouteWithChildren,
  AppMeetingTemplatesRoute: AppMeetingTemplatesRouteWithChildren,
  AppMessagesRoute: AppMessagesRoute,
  AppNpsResponsesRoute: AppNpsResponsesRoute,
  AppSkillsRoute: AppSkillsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCohortsCreateRoute: AppCohortsCreateRoute,
  AppConversationReviewsIdRoute: AppConversationReviewsIdRoute,
  AppDashboardCostsRoute: AppDashboardCostsRoute,
  AppDashboardMetricsHistoryRoute: AppDashboardMetricsHistoryRoute,
  AppDashboardPageUsageRoute: AppDashboardPageUsageRoute,
  AppDashboardQuestionsRoute: AppDashboardQuestionsRoute,
  AppOrganisationsCreateRoute: AppOrganisationsCreateRoute,
  AppTopicsIdRoute: AppTopicsIdRoute,
  AppTracesTraceIdRoute: AppTracesTraceIdRoute,
  AppTracksCreateRoute: AppTracksCreateRoute,
  AppUsersCreateRoute: AppUsersCreateRoute,
  AppCohortsIndexRoute: AppCohortsIndexRoute,
  AppConversationReviewsIndexRoute: AppConversationReviewsIndexRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppOrganisationsIndexRoute: AppOrganisationsIndexRoute,
  AppTopicsIndexRoute: AppTopicsIndexRoute,
  AppTracksIndexRoute: AppTracksIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppCohortsIdEditRoute: AppCohortsIdEditRoute,
  AppOrganisationsIdEditRoute: AppOrganisationsIdEditRoute,
  AppTracksIdEditRoute: AppTracksIdEditRoute,
  AppUsersIdEditRoute: AppUsersIdEditRoute,
  AppCohortsIdIndexRoute: AppCohortsIdIndexRoute,
  AppOrganisationsIdIndexRoute: AppOrganisationsIdIndexRoute,
  AppTracksIdIndexRoute: AppTracksIdIndexRoute,
  AppUsersIdIndexRoute: AppUsersIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ConnectRoute: ConnectRoute,
  RoleplayRoute: RoleplayRoute,
  AuthErrorRoute: AuthErrorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
